// Mercapoli - Componente de Ruta Protegida
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

const ProtectedRoute = ({ children, roles = [] }) => {
  const { user, loading, isAuthenticated } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <Loader2 className="h-12 w-12 animate-spin text-primary mx-auto" />
          <p className="mt-4 text-muted-foreground">Cargando...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (roles.length > 0 && !roles.includes(user?.rol)) {
    // Redirigir según el rol
    const redirectMap = {
      customer: '/app',
      delivery: '/delivery',
      restaurant: '/restaurant',
      admin: '/admin'
    };
    
    return <Navigate to={redirectMap[user?.rol] || '/'} replace />;
  }

  return children;
};

export default ProtectedRoute;
